require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/fn/get-iterator.js
// module id = 630
// module chunks = 0